var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"app"}},[(_vm.pendingStoreActions.includes('getBrandTheme'))?_c('BrandThemeLoading'):_vm._e(),_vm._v(" "),(!_vm.pendingStoreActions.includes('getBrandTheme'))?_c('router-view',{class:{ 'is-offline': _vm.isOffline }}):_vm._e(),_vm._v(" "),_c('OfflineIndicator'),_vm._v(" "),(_vm.shouldShowCookiePolicy)?_c('CookiesPolicy',{on:{"clickAcceptance":_vm.acceptCookiePolicy}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79f565f8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1005
// module chunks = 11